import angular from "angular";
import UcetService from "./UcetService";
import { EditCtrl } from "../Editor";

export default angular
.module("energis.ucet", [])
.config(function routes($stateProvider){
  $stateProvider
  .state("ucet-edit", {
    url: "/ucty/{id:int}/edit",
    template: require("./ucet.edit.html"),
    controller: EditCtrl,
    controllerAs: "ctrl",
    resolve: {
      item: ($stateParams, UcetService) => UcetService.get($stateParams.id),
      saveHandler: (UcetService) => (id, item) => UcetService.save(id, item)
    }
  })
})
.service("UcetService", UcetService)
.name;



// WEBPACK FOOTER //
// ./src/Ucet/index.js